import { useEffect } from "react";
import { isMobileUx } from "./useMobileUx.js";

type ContextMenuEvent = {
  preventDefault: () => void;
  stopPropagation: () => void;
};

export function suppressMobileContextMenu(e: ContextMenuEvent): boolean {
  if (!isMobileUx()) return false;
  e.preventDefault();
  e.stopPropagation();
  return true;
}

export function useDisableMobileContextMenu(): void {
  useEffect(() => {
    if (!isMobileUx()) return;
    const swallow = (e: Event) => {
      e.preventDefault();
      e.stopPropagation();
    };
    window.addEventListener("contextmenu", swallow, true);
    return () => window.removeEventListener("contextmenu", swallow, true);
  }, []);
}
